import React, { useState, useEffect } from 'react';
  import { motion, AnimatePresence } from 'framer-motion';
  import { Search, Video, ChevronRight, X } from 'lucide-react';

  function HelpCenter() {
    const [selectedTutorial, setSelectedTutorial] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredTutorials, setFilteredTutorials] = useState([]);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const categories = [
      { id: '1', name: 'Introducción al Sistema' },
      { id: '2', name: 'Gestión de Embarcaciones' },
      //{ id: '3', name: 'Reservas y Alquileres' },
     // { id: '4', name: 'Facturación y Pagos' },
     // { id: '5', name: 'Mantenimiento y Servicios' },
    ];

    const tutorials = [
      { id: '1', title: 'Bienvenidos a DRIZA', category: '1', videoUrl: 'https://www.youtube.com/embed/eqIEC4Ye6y4' },
      //{ id: '2', title: 'Navegación Básica', category: '1', videoUrl: 'https://drive.google.com/file/d/example2/preview' },
      { id: '3', title: 'Asociar embarcacion a varios clientes', category: '2', videoUrl: 'https://www.youtube.com/embed/vy-0fO3tPKo' }, // Enlace corregido
      { id: '4', title: 'Seleccionar vehiculo para embarcacion', category: '2', videoUrl: 'https://www.youtube.com/embed/-I8HHqaTgRc' }, // Corrected URL
      { id: '5', title: 'Registrar salida embarcacopm', category: '2', videoUrl: 'https://www.youtube.com/embed/-BlyI8sx6BU' },
    ];

    useEffect(() => {
      const lowercasedQuery = searchQuery.toLowerCase();
      const filtered = tutorials.filter((tutorial) =>
        tutorial.title.toLowerCase().includes(lowercasedQuery) ||
        categories.find((cat) => cat.id === tutorial.category)?.name.toLowerCase().includes(lowercasedQuery)
      );
      setFilteredTutorials(filtered);
    }, [searchQuery]);

    const handleSelectTutorial = (tutorial) => {
      setSelectedTutorial(tutorial);
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false);
      }
    };

    return (
      <div className="flex h-screen bg-[#1B4F72] text-[#FAFAFA]">
        {/* Sidebar */}
        <motion.div 
          className={`fixed inset-y-0 left-0 z-50 w-80 bg-[#1B4F72] shadow-lg transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out`}
          initial={false}
          animate={{ width: isSidebarOpen ? '20rem' : '0rem' }}
        >
          <div className="h-full flex flex-col p-4">
            <h1 className="text-2xl font-bold mb-4 text-[#F1C40F]">Centro de Ayuda</h1>
            <div className="relative mb-4">
              <input
                type="text"
                placeholder="Buscar tutoriales..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 bg-[#3498DB] text-[#FAFAFA] placeholder-[#BDC3C7] border-none rounded-md focus:outline-none focus:ring-2 focus:ring-[#2ECC71]"
              />
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#BDC3C7]" />
            </div>
            <div className="flex-grow overflow-y-auto">
              {categories.map((category) => (
                <div key={category.id} className="mb-4">
                  <h2 className="text-lg font-semibold mb-2 text-[#2ECC71]">{category.name}</h2>
                  <AnimatePresence>
                    {filteredTutorials
                      .filter((tutorial) => tutorial.category === category.id)
                      .map((tutorial) => (
                        <motion.div
                          key={tutorial.id}
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -10 }}
                          transition={{ duration: 0.2 }}
                        >
                          <button
                            className="w-full text-left mb-2 px-2 py-2 bg-[#3498DB] text-[#FAFAFA] hover:bg-[#27AE60] rounded-md transition-all duration-200"
                            onClick={() => handleSelectTutorial(tutorial)}
                          >
                            <Video className="h-4 w-4 mr-2 inline-block" />
                            {tutorial.title}
                          </button>
                        </motion.div>
                      ))}
                  </AnimatePresence>
                </div>
              ))}
            </div>
          </div>
        </motion.div>

        {/* Main Content */}
        <div className={`flex-1 p-8 ${isSidebarOpen ? 'ml-80' : 'ml-0'} transition-all duration-300 ease-in-out`}>
          <button
            className="mb-4 px-4 py-2 bg-[#3498DB] text-[#FAFAFA] hover:bg-[#2980B9] rounded-md"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {isSidebarOpen ? <X className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
          </button>

          {selectedTutorial ? (
            <motion.div
              key={selectedTutorial.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="space-y-4"
            >
              <h2 className="text-3xl font-bold text-[#F1C40F]">{selectedTutorial.title}</h2>
              <div className="bg-[#2ECC71] text-[#FAFAFA] px-2 py-1 rounded-md inline-block">
                {categories.find((cat) => cat.id === selectedTutorial.category)?.name}
              </div>
              <div className="aspect-video rounded-xl overflow-hidden shadow-lg bg-[#3498DB]">
                <iframe
                  src={selectedTutorial.videoUrl}
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>
            </motion.div>
          ) : (
            <div className="flex flex-col items-center justify-center h-full text-[#BDC3C7]">
              <Video className="h-16 w-16 mb-4" />
              <p className="text-xl">Selecciona un tutorial para comenzar</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  export default HelpCenter;